export default __webpack_public_path__ + "static/media/size_icon_2.badf047f.svg";